<template>
  <tr>
    <td>{{item.id}}</td>
      <td>{{item.ref}}</td>
      <td>{{item.username}}</td>
      <td>{{dateCreated}}</td>
      <td>{{leadsCount}}</td>
      <td>
        {{conversions}}
        <br>
        <span class="tag">{{conversionPercent}}%</span>
      </td>
      <td>
        <button class="button" v-if="item.active === 1"
         @click="deactivateRef">
          פעיל
        </button>
        <button class="button" v-else
        @click="activateRef">
          לא פעיל
        </button>
      </td>
      <td>
        <router-link class="button is-info"
        :to="{name: 'ref', params:{
          id: this.item.id}}">
        פירוט מלא</router-link>
      </td>
  </tr>
</template>

<script>
export default {
  props: {
    item: Object
  },

  computed: {
    dateCreated() {
      const date = new Date(this.item.date_created);
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    },

    leadsCount() {
      return this.item.leads.length;
    },
    conversions() {
      const conversions = this.item.leads.filter(c => c.status > 0);
      return conversions.length;
    },
    conversionPercent() {
      if (this.leadsCount === 0) {
        return 0;
      }
      const num = this.conversions / this.leadsCount;
      return num.toFixed(2) * 100;
    }
  },

  methods: {
    deactivateRef() {
      this.$store.dispatch("deactivateRef", this.item);
    },
    activateRef() {
      this.$store.dispatch("activateRef", this.item);
    }
  }
};
</script>

<style>
</style>
